import React from 'react';
import { GridItem, Stepper } from '@guestyci/arc';
import t from '@guestyci/localize/t.macro';
import { useBreakpoint } from '../../utils/useBreakpoint';

const StepperBlock = ({ currentStep = 1 }) => {
  const stepIndex = currentStep - 1;

  const onboardingSteps = [
    { id: 'password', label: t('Password') },
    { id: 'authentication', label: t('Authentication') },
    { id: 'payment', label: t('Payment method') },
  ];
  const isDesktop = useBreakpoint('lg');

  const gridItemStyle = isDesktop ? undefined : { marginInline: -20 };
  const innerStyle = isDesktop ? { maxWidth: 420 } : { paddingInline: 13 };

  return (
    <GridItem
      gridColumnStart={{ xs: 1, lg: 1 }}
      gridRowStart={{ xs: 2, lg: 1 }}
      className="gst-flex gst-justify-center lg:gst-pt-16"
      style={gridItemStyle}
    >
      <div className="gst-w-full" style={innerStyle}>
        <Stepper
          steps={onboardingSteps}
          orientation="horizontal"
          activeStep={[stepIndex]}
          currentStep={[stepIndex]}
          labelClasses={{
            pending: 'gst-text-sm',
            active: 'gst-text-sm',
            completed: 'gst-text-sm',
          }}
        />
      </div>
    </GridItem>
  );
};

export default StepperBlock;
